import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Module-level cache so the fetch only happens once per page load — the
// config never changes within a session.
let cached = null;
let inFlight = null;

/** Hook that returns { default_donation_url, fundraising_categories } from
 *  `/api/config/public`. Returns null until loaded. */
export function usePublicConfig() {
  const [cfg, setCfg] = useState(cached);
  useEffect(() => {
    if (cached) { setCfg(cached); return; }
    if (!inFlight) {
      inFlight = axios.get(`${API}/config/public`, { timeout: 8000 })
        .then((r) => { cached = r.data; return r.data; })
        .catch(() => { cached = {}; return {}; })
        .finally(() => { inFlight = null; });
    }
    inFlight.then((data) => setCfg(data));
  }, []);
  return cfg;
}
